/**
 * Single source of truth for the home trip-type options (One-way / Round-trip / Multi-city).
 *
 * Both the desktop radios (DesktopSearchForm) and the PWA tabs (MobileSearchForm) render from
 * this list, so:
 *   - toggling a "NEW"-style badge on any option  → add / remove its `badgeKey`
 *   - changing a label                            → change its `labelKey`
 *   - adding / removing an option                 → add / remove an entry
 *
 * All keys resolve against the `common` i18n namespace, so text is handled for en and ar.
 */

export type TripTypeValue = 'oneway' | 'roundtrip' | 'multicity'

/** i18n keys under the `common` namespace. */
type TripTypeLabelKey = 'oneWay' | 'roundTrip' | 'multicity'
type TripTypeBadgeKey = 'new'

export interface TripTypeTabConfig {
    value: TripTypeValue
    labelKey: TripTypeLabelKey
    /** When set, a badge with this label is shown on the option. Remove to hide it. */
    badgeKey?: TripTypeBadgeKey
    /** Option is hidden when multi-city is disabled for the domain (`hideMulticity`). */
    requiresMulticity?: boolean
}

export const TRIP_TYPE_TABS: TripTypeTabConfig[] = [
    { value: 'oneway', labelKey: 'oneWay' },
    { value: 'roundtrip', labelKey: 'roundTrip' },
    { value: 'multicity', labelKey: 'multicity', requiresMulticity: true }
]

/** Trip-type options visible for the current domain configuration. */
export const getVisibleTripTypeTabs = (hideMulticity?: boolean): TripTypeTabConfig[] =>
    TRIP_TYPE_TABS.filter(tab => !tab.requiresMulticity || !hideMulticity)
